export const VisibilityOnIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.75 12C21.75 14.25 17.385 18.75 12 18.75C6.615 18.75 2.25 14.25 2.25 12C2.25 9.75 6.615 5.25 12 5.25C17.385 5.25 21.75 9.75 21.75 12Z"
        stroke="white"
        stroke-opacity="0.3"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M15.75 12C15.75 12.9946 15.3549 13.9484 14.6517 14.6517C13.9484 15.3549 12.9946 15.75 12 15.75C11.0054 15.75 10.0516 15.3549 9.34835 14.6517C8.64509 13.9484 8.25 12.9946 8.25 12C8.25 11.0054 8.64509 10.0516 9.34835 9.34835C10.0516 8.64509 11.0054 8.25 12 8.25C12.9946 8.25 13.9484 8.64509 14.6517 9.34835C15.3549 10.0516 15.75 11.0054 15.75 12Z"
        stroke="white"
        stroke-opacity="0.3"
        stroke-width="2"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default VisibilityOnIcon;
